<script>
    export default {
        name: "HorizontalLineElement",
        data() {
            return {
                elementType: 'horizontalLine',
            }
        },
    }
</script>
